// @flow
import React from 'react'
import type { Node as ReactNode } from 'react'
import cn from 'classnames'
import style from './Regular.css'
import { parseUnitsToString } from '../../../../utils/parseUnits/parseUnits'
import { transformBar } from '../../../../utils/barUtils/barUtils'

type Props = {
  data: Object,
  highestNumber: number,
  accent: boolean,
  fields: Object
}
type State = {
  hasMounted: boolean
}

class TwoNumberBar extends React.PureComponent<Props, State> {
  static defaultProps = {
    accent: false
  }
  state = {
    hasMounted: false
  }
  componentDidMount() {
    setTimeout(() =>
      this.setState(() => {
        return {
          hasMounted: true
        }
      })
    )
  }

  render(): ReactNode {
    const { data, highestNumber, accent, fields } = this.props || ''
    const { hasMounted } = this.state
    const valueFields = fields.filter(f => f.role === 'value')

    const growthInPercent = data[valueFields[0].id]
      ? data[valueFields[0].id] / highestNumber * 100
      : 0

    const FirstStringToShow = parseUnitsToString(valueFields[0], data)
    const SecondStringToShow = parseUnitsToString(valueFields[1], data)

    return (
      <tr className={cn(style.tnr)}>
        <td className={cn(style.tnrCol, style.tnrColGraph)}>
          <span>{data.name}</span>
          <span
            aria-hidden
            className={cn(style.tnrGraph, { [style.aAccent]: accent })}
            style={hasMounted ? transformBar(growthInPercent) : transformBar(0)}
          />
        </td>
        <td className={cn(style.tnrCol, style.tnrColNumber)}>
          <span className={cn(style.tnrNumber)}>{FirstStringToShow}</span>
        </td>
        <td className={cn(style.aCol, style.aColNumber)}>
          <span className={cn(style.tnrNumber)}>{SecondStringToShow}</span>
        </td>
      </tr>
    )
  }
}

export default TwoNumberBar



// WEBPACK FOOTER //
// ./src/shared/components/Bars/TwoNumbers/Regular/Regular.js